import {
  ByIdPayload,
  FailByIdPayload,
  NormalizedSingle,
  OperationReducerTypes,
  PayloadAction,
  SendByIdPayload,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';
import { WarehousePayload } from '../models/warehouse-payload';

export const WarehouseEditActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[warehouse] Edit'),
  requestFail: uniqueActionType('[warehouse] Edit fail'),
  requestSuccess: uniqueActionType('[warehouse] Edit success'),
  requestClearErrors: uniqueActionType('[warehouse] Edit clear errors'),
  requestClear: uniqueActionType('[warehouse] Edit clear')
};

export class WarehouseEditAction implements PayloadAction {
  readonly type = WarehouseEditActionTypes.request;

  constructor(public payload: SendByIdPayload<WarehousePayload>) {
  }
}

export class WarehouseEditFailAction implements PayloadAction {
  readonly type = WarehouseEditActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class WarehouseEditSuccessAction implements PayloadAction {
  readonly type = WarehouseEditActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedSingle>) {
  }
}

export class WarehouseEditClearErrorsAction implements PayloadAction {
  readonly type = WarehouseEditActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}

export class WarehouseEditClearAction implements PayloadAction {
  readonly type = WarehouseEditActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}
